import { connect } from 'react-redux';

import Counter from '../components/Counter';
import { addCounter, removeCounter } from '../actions/counterActions';

const mapStateToProps = state => ({
  counter: state.counterReducer.counter,
});

const mapDispatchToProps = dispatch => ({
  addCounter: () => {
    dispatch(addCounter());
  },
  removeCounter: () => {
    dispatch(removeCounter());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Counter);
